import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export const useEditField = <T>(value: T): [T, Dispatch<SetStateAction<T>>] => {
  const [stagedValue, setStagedValue] = useState(value);

  useEffect(() => {
    setStagedValue(value);
  }, [value]);

  return [stagedValue, setStagedValue];
};
